import { accessRole } from "../../../helpers/access_role"
import ErrorAccess from '../../../components/Error/Content/Access'

import IndexView from "./Index/View"
import IndexPegawaiView from "./IndexPegawai/View"
import UploadSKView from "./UploadSK/View"
import CreateManualView from "./CreateManual/View"

import CreateView from "./Create/View"
import DetailView from "./Detail/View"

const RouteView = (props) => {

  const queryParams = new URLSearchParams(props.location.search);
  const _create = queryParams.get('create')
  const _create_manual = queryParams.get('create_manual')
  const _detail = queryParams.get('detail')
  const _delete = queryParams.get('delete')
  const _approve = queryParams.get('approve')
  const _print = queryParams.get('print')
  const _update = queryParams.get('update')

  const _pegawai = queryParams.get('pegawai')
  const _upload_sk = queryParams.get('upload_sk')
  const _uuid = queryParams.get('uuid')

  if (_create != null) {
    return accessRole('create') ? <CreateView /> : <ErrorAccess />
  } else if (_detail != null) {
    return accessRole('read') ? <DetailView/> : <ErrorAccess />
  }else if (_update != null) {
    return accessRole('update') ? null : <ErrorAccess />
  } else if (_delete != null) {
    return null
  } else if (_approve != null) {
    return accessRole('approve') ? null : <ErrorAccess />
  } else if (_pegawai != null) {
    return accessRole('read') ? <IndexPegawaiView/> : <ErrorAccess />
  } else if (_upload_sk != null) {
    return accessRole('create') ? <UploadSKView/> : <ErrorAccess />
  } else if (_create_manual != null) {
    return accessRole('create') ? <CreateManualView/> : <ErrorAccess />
  } else if (_print != null) {
    return null
  }
  return accessRole('read') ? <IndexView /> : <ErrorAccess />

}
export default RouteView
